exports.debounce = function (i, e, o) {
  var t;
  return void 0 === e && (e = 50), void 0 === o && (o = {
    isImmediate: !1
  }), function () {
    for (var a = [], d = 0; d < arguments.length; d++) {
      a[d] = arguments[d];
    }

    var n = this,
        m = o.isImmediate && void 0 === t;
    void 0 !== t && clearTimeout(t), t = setTimeout(function () {
      t = void 0, o.isImmediate || i.apply(n, a);
    }, e), m && i.apply(n, a);
  };
};